<template>
    <div>
        <section style="height: 100vh;overflow: hidden;">
            <div style="height: 100vh;position: relative;">
                <div class="swiper-container-top swiper-no-swiping" style="position: relative;">
                    <div class="swiper-wrapper ">
                        <div class="swiper-slide my-swiper" style="height: 100vh;"
                        :style="{backgroundImage:'url('+img.imgUrl+')'}"
                         v-for="(img,index) in bannerList" :key="index">
                        </div>
                    </div>
                </div>
                <div style="position: absolute;z-index: 2;top: 0;">
                    <el-row    class="page-top1" type="flex" justify="center" align="center">
                            <el-col :md="6" align="center" style="position: relative;">
                                <el-col :md="24" style="position: absolute;opacity: .2;letter-spacing: 5px;font-weight: bold;">
                                    <h1 >OUR SERVICE</h1>
                                </el-col>
                                <el-col :md="24">
                                    <h1 style="color: #fff;font-weight: bold;">{{$t('service.toptitle')}}</h1>
                                    <h6>OUR SERVICE</h6>
                                    <h6>{{$t('service.linfo')}}</h6>
                                </el-col>
                                
                            </el-col>
                    </el-row>
                </div>
                <el-row type="flex" justify="center" align="center" class="menu ">
                    <el-col :md="10"  align="center" class="item" @click.native="selectModel(0)" :class="idx == 0 ? 'lose':'active'">
                        <h4>{{$t('service.biogaia')}}</h4>
                    </el-col>
                    <el-col :md="10"  align="center" class="item" @click.native="selectModel(1)" :class="idx == 1 ? 'lose':'bactive'">
                        <h4>{{$t('service.hmltitle')}}</h4>
                    </el-col>
                </el-row>
                <el-row type="flex" justify="center">
                    <div class="more-page">
                        <p class="iconfont mh-weibiaoti-1-18"></p>
                        <p class="iconfont mh-weibiaoti-1-19 one"></p>
                        <p class="iconfont mh-weibiaoti-1-19 two"></p>
                    </div>
                </el-row>
            </div>
        </section>
        
        <el-row justify="center"  v-show="show" type="flex" class="service-top">
            <el-col :md="12" :xs="22" :sm="22">
                <el-col :md="24" :xs="22" :sm="22">
                    <div class="title-opt">INTRODUCTION</div>
                    <div class="title-opt-title">{{$t('service.baiao.profile')}}</div>
                </el-col>
                <el-col :md="24" :xs="24" :sm="24" class="hidden-md-and-up">
                    <div>
                        <img src="https://scan-code.oss-cn-hangzhou.aliyuncs.com/menhu/service/baiao-top.jpg" width="100%" />
                    </div>
                </el-col>
                <el-col :md="24" :xs="24">
                    <el-col :md="24" :xs="24" style="margin-top: 20px;">
                           <p> {{$t('service.baiao.info1')}}</p>
                           <p>{{$t('service.baiao.info2')}}</p>
                           <p style="font-weight: bold;font-size: 30px;">{{$t('service.baiao.info3.date')}}</p>
                           <p>{{$t('service.baiao.info3.info')}}</p>
                    </el-col>
                </el-col>
            </el-col>
            <el-col :md="10" :xs="24" class="hidden-sm-and-down">
                <el-row type="flex" justify="end">
                    <el-col :md="20" class="right" :xs="6" >
                        <img src="https://scan-code.oss-cn-hangzhou.aliyuncs.com/menhu/service/baiao-top.jpg" width="100%" alt="">
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
        
        
        
        <el-row justify="center"  v-show="!show" type="flex" class="service-top">
            <el-col :md="12" :xs="22" :sm="22">
                <el-col :md="24" :xs="22" :sm="22">
                    <div class="title-opt">INTRODUCTION</div>
                    <div class="title-opt-title">{{$t('service.hml.profile')}}</div>
                </el-col>
                <el-col :md="24" :xs="24" :sm="24" class="hidden-md-and-up">
                    <div>
                        <img src="https://scan-code.oss-cn-hangzhou.aliyuncs.com/menhu/service/hml-top.jpg" width="100%" />
                    </div>
                </el-col>
                <el-col :md="24" :xs="24">
                    <el-col :md="24" :xs="24" style="margin-top: 20px;">
                           <p>{{$t('service.hml.info1')}}
                           </p>
                           <p>{{$t('service.hml.info2')}}</p>
                             <p> {{$t('service.hml.info3.info')}}</p>
                    </el-col>
                </el-col>
            </el-col>
            <el-col :md="10" :xs="24" class="hidden-sm-and-down">
                <el-row type="flex" justify="end">
                    <el-col :md="20" class="right" :xs="6" >
                        <img src="https://scan-code.oss-cn-hangzhou.aliyuncs.com/menhu/service/hml-top.jpg" width="100%" alt="">
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
        
        <el-row class="hml-two" type="flex" justify="center" v-if="idx == 1">
            <el-col :md="23">
                <el-col :md="24" type="flex" justify="center" >
                    <el-col :md="24" >
                        <div class="m-m-title">
                            <div ><p>PUBLIC WEI FARE</p></div>
                            <div ><p>{{$t('service.hml.gy.title')}}</p></div>
                        </div>
                    </el-col>
                </el-col>
                <el-col :md="24" >
                    <el-row class="tow-main"  type="flex" justify="space-around">
                        <el-col :md="10" :xs="24" class="left">
                            <div class="content" style="line-height: 28px;">
                                <div>
                                    <p>{{$t('service.hml.gy.info')}}</p>
                                    <p>{{$t('service.hml.gy.info1')}}</p>
                                </div>
                                <div>
                                     {{$t('service.hml.gy.btm1')}}
                                     {{$t('service.hml.gy.btm2')}}
                                </div>
                            </div>
                            <div class="btn hidden-sm-and-down">
                                <p>{{$t('service.hml.gy.subtitle')}}</p>
                                <div class="btns">
                                    <el-button style="background-color: #5b917a;color: #fff;" >{{$t('service.hml.gy.service')[0].title}}</el-button>
                                    <el-button style="background-color: #5b917a;color: #fff;" >{{$t('service.hml.gy.service')[1].title}}</el-button>
                                    <el-button style="background-color: #5b917a;color: #fff;" >{{$t('service.hml.gy.service')[2].title}}</el-button>
                                    <el-button style="background-color: #5b917a;color: #fff;" >{{$t('service.hml.gy.service')[3].title}}</el-button>
                                </div>
                            </div>
                        </el-col>
                        <el-col :md="10" :xs="22"  class="right"></el-col>
                        <el-col :xs="22" class="hidden-md-and-up serBtn"  >
                            <el-col :xs="24" style="padding: 15px 5px;">
                                {{$t('service.hml.gy.subtitle')}}
                            </el-col>
                            <el-col :xs="24" class="serBtnList">
                                <el-col :xs="12">
                                    <div class="btn">{{$t('service.hml.gy.service')[0].title}}</div>
                                </el-col>
                                <el-col :xs="12" ><div class="btn">{{$t('service.hml.gy.service')[1].title}}</div></el-col>
                                <el-col :xs="12"><div class="btn">{{$t('service.hml.gy.service')[2].title}}</div></el-col>
                                <el-col :xs="12"><div class="btn">{{$t('service.hml.gy.service')[3].title}}</div></el-col>
                            </el-col>
                        </el-col>
                        
                    </el-row>
                </el-col>
            </el-col>
        </el-row>
        
        
        
 
        <el-row  type="flex" justify="center" style="margin-top: 50px;" class="hidden-sm-and-down">
            <el-col :md="22" :xs="24">
                <el-col :md="24" class="h-menu-title">
                    <div class="news-sub">PRODUCT</div>
                    <div class="news-title" >{{idx == 0 ? $t('service.baiao.protag'):$t('service.hml.protag')}}</div>
                </el-col>
                <el-col :md="24" ref="swiperMain" :sm="24" style="overflow: hidden;" >
                    <moduleSwiper ref="mmswp" :list="swpList" :mainWidth="22"></moduleSwiper>
                </el-col>
            </el-col>
        </el-row>
        
        <myBaiao v-show="show"/>
        <hml v-show="!show" :list="aed_list"/>
    </div>
</template>
<script>
    import hml from '@/components/hml/hmlView.vue'
    import myBaiao from '@/components/myBaiao/myBaiao.vue'
    import Swiper from 'swiper'
    const moduleSwiper = () => import('@/components/moduleSwiper/moduleSwiper.vue')
    export default{
        components:{
            myBaiao,hml,moduleSwiper
        },
        computed:{
            curentList(){
                if(this.idx == 0){
                    //console.log(this.idx)
                    return this.product_list
                }else{
                    //console.log(this.idx)
                    return this.aed_list
                }
            }
        },
        data(){
            return{
                show:true,
                topSp:{},
                idx:0,
                swpList:[],
                bannerList:[
                    {imgUrl:'https://scan-code.oss-cn-hangzhou.aliyuncs.com/menhu/pageBg/service.jpg'},
                    {imgUrl:'https://scan-code.oss-cn-hangzhou.aliyuncs.com/menhu/pageBg/hml.jpg'}
                ],
                product_list:this.$t('service.baiao.list'),
                aed_list:this.$t('service.hml.list')
            }
        },
        mounted() {
            let that = this
            that.swpList = that.product_list
             var topSwiper = new Swiper(".swiper-container-top", {
                loop: true,
                onwheel:true,
                effect: 'fade',
                pagination: {
                    el: ".swiper-pagination",
                },                    
            });
            that.topSp = topSwiper
            
        },
        methods:{
            selectModel(idx){
                this.idx = idx
                switch(idx){
                    case '0':
                        this.swpList = []
                        this.swpList = this.product_list
                        this.show = true
                        this.$refs.mmswp.setCurrentItem(this.product_list,0);
                        break;
                    case '1':
                        this.swpList = []
                        this.swpList = this.aed_list
                        this.show = false
                        this.$refs.mmswp.setCurrentItem(this.aed_list,1);
                        break;
                }
                this.topSp.slideToLoop(idx,1000,false)
            },
        }
        
    }
</script>
<style lang="scss" scoped>
    @import '../assets/mh.scss';
    $title-panel-sub:#acacac;
    $title-panel-sub_opacity:.2;
    $title-panel-title:#443530;
    $title-panel-title_size:18px;
    $content-font:14px;
    .service-top{
        @media only screen and (min-width:500px){
            height: 100vh;
            align-items: center;
        }
        @media only screen and (max-width:500px){
            height: auto;
        }
        .right{
            background-size: cover;
            background-position: center;
        }
        p{
            font-size: 16px;
        }
    }
    .serBtn{
        margin-top: 10px;
        .serBtnList{
            padding: 0 5px;
            font-size: 18px;
            .el-col{
                padding: 2px 5px;
            }
            .btn{
                width: 100%;
                background-color: #5b917a;
                padding: 5px ;
                font-size: 14px;
            }
        }
    }
    .hml-btm{
        .hml-content{
            flex-direction: column;align-items: center;
            .content{
                margin-top: 20px;
                .info{
                    .msg{
                        width: 100%;
                        height: 100%;
                        display: flex;
                        background-color: #f27c5e;
                        justify-content: center;
                        align-items: center;
                        color: #FFF;
                    }
                    overflow: hidden;
                   & > div{
                       border-radius: 10px;
                   }
                    height: 200px;padding-top: 10px;
                    height: 200px;
                    align-items: center;
                    display: flex;
                    justify-content: center;
                    .img{
                        height: 100%;
                        width: 100%;
                        background-image: url('../assets/images/3.jpg');
                        background-size: cover;
                    }
                }
                
            }
        }
    }
    .tow-main{
        @media only screen and (max-width:920px){
            flex-direction: column;
            align-items: center;
        }
        .right{
            background-image: url('https://scan-code.oss-cn-hangzhou.aliyuncs.com/menhu/service/hml/hml-gy.jpg');
            background-size: cover;
            height: 500px;
        }
        .left{
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            
            @media only screen and (min-width:920px){
                height: 500px;
            }
            
            .content{
                div:first-child{
                    text-indent: 30px;
                    margin-bottom: 30px;
                    padding: 5px;
                }
                font-size: $content-font;
                height: 100%;
            }
            .btn{
                padding: 0;
                text-align: left;
                p{
                    padding:0 5px;
                    font-size: $title-panel-title_size;
                    color: $title-panel-title;
                    font-weight: bold;
                    
                }
                .btns{
                   
                    display: flex;
                    flex-wrap: wrap;
                    .el-button{
                        border: none;
                        margin: 5px;
                        width: 46%;
                    }
                }
            }
        }
    }
    .title-module{
        position: relative;
        text-align: center;
        .title-sub{
            color: $title-panel-sub;
            opacity: $title-panel-sub_opacity;
            font-size: 40px;
            letter-spacing: 3px;
        }
        p{
            font-weight: bold;
            
        }
        .title{
            position: relative;
            top: -50px;
            font-weight: bold;
            font-size:$title-panel-title_size ;
            color: $title-panel-title;
        }
    }
    .hml-two{
        @media only screen and (min-width:920px){
            height: 100vh;
        }
        flex-direction: column;
        align-items: center;
    }
    .menu{
        letter-spacing: 3px;
        width: 100%;
        position: absolute;
        z-index: 99;
        bottom: 0;
        .item{
            transition: background .4s ease-in-out;
            padding: 15px 0;
            &+.item{
                border-left: 1px solid #acacac;
            }
        }
        .active{
            background-color: #BA4D48;
            color: #FFF;
        }
        .bactive{
            background-color: #5b917a;
            color: #FFF;
        }
        .lose{
            background-color: #FFF;
            color: #000
        }
    }
    .page-top1{
        height: 100vh;
        width: 100vw;
        position: relative;
        align-items: center;
        .page-title{
            height: 100vh;
            align-items: center;
            display: flex;
            
        }
        h1{
            color: #fff;
            font-weight: bold;
        }
        h6{
            &+h6{
               border-top: 1px solid #acacac; 
               letter-spacing: 3px;
            }
            color: #fff;
            padding: 20px 0;
        }
    }
    
    .my-swiper{
        height: var(--h);
        width: var(--w);
        background-size: cover;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #FFFFFF;
        .parallax-bg{
            position: absolute;
            left: 0;
            top: 0;
            width: 130%;
            height: 100%;
            -webkit-background-size: cover;
            background-size: 100% 100%;
            background-position: center;
        }
    }
    .btnMini{
        display: flex;
        flex-direction: column;
        
    }
</style>